import ArrowForwardIosOutlined from '@mui/icons-material/ArrowForwardIosOutlined';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React, { ReactNode } from 'react';

interface PortalActionProps {
  title: string;
  description: string;
  route: string;
  icon: ReactNode;
  iconColour: string;
  testId: string;
}

function PortalAction({ title, description, route, icon, iconColour, testId }: PortalActionProps) {
  return (
    <ButtonBase
      component={Link}
      data-testid={testId}
      to={route}
      sx={{
        display: 'block',
        width: '100%',
        height: '100%',
        textAlign: 'left',
        borderRadius: 2,
      }}
    >
      <Paper
        elevation={2}
        sx={{
          height: '100%',
          border: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          overflow: 'hidden',
          borderRadius: 2,
          transition: 'border-color 150ms ease, transform 150ms ease, box-shadow 150ms ease',
          '&:hover': {
            borderColor: iconColour,
            transform: 'translateY(-2px)',
            boxShadow: 5,
          },
        }}
      >
        <Box
          sx={{
            p: 2.5,
            display: 'flex',
            alignItems: 'center',
            gap: 2.25,
          }}
        >
          <Box
            sx={{
              width: 58,
              color: iconColour,
              flexShrink: 0,
              fontSize: 48,
              lineHeight: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '& svg': {
                fontSize: 48,
              },
            }}
          >
            {icon}
          </Box>

          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 800 }}>
              {title}
            </Typography>

            <Typography variant="body2" component="p" color="text.secondary">
              {description}
            </Typography>
          </Box>

          <ArrowForwardIosOutlined sx={{ fontSize: 16, flexShrink: 0, color: iconColour }} />
        </Box>
      </Paper>
    </ButtonBase>
  );
}

export default PortalAction;
